/** IBAN / BIC — saisie et copie. */

export function compactIban(raw: string): string {
  return raw.toUpperCase().replace(/[^A-Z0-9]/g, "");
}

export function formatIban(raw: string): string {
  return compactIban(raw).slice(0, 34).replace(/(.{4})/g, "$1 ").trim();
}

export function compactBic(raw: string): string {
  return raw.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 11);
}
